import React from 'react';
import '../Estilos/Estilo.scss';
import { Paginacion, getCurrentPage } from '../util/paginacion';
import Spinner from "react-bootstrap/Spinner";
import { useState } from 'react';


class CardPublications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            key: props.id,
            id: props.id,
            publicaciones: props.pub,
            currentPagepublicaciones: 1,
            loadingpublicaciones: true,
            publicacionesActuales: [],
            itemPerPage: props.item,
            vacia: false,
            numTotal: 0,
            isToggleOn: 'ON'

        };
        if (this.state.publicaciones.length <= 0) {
            this.state.vacia = true;
        } else {
            this.state.numTotal = this.state.publicaciones.length;
        }
    }
    actualizacionDePagina = () => {
        if(getCurrentPage(this.state.id) !== this.state.currentPagepublicaciones){
            this.setState({currentPagepublicaciones: getCurrentPage(this.state.id)});
            window.scrollTo(0,0);
        }
    }

    render() {
        return (
            <div>
                <div>

                    {/*{this.state.vacia ? <h1>No hay publicacioness que mostrar</h1> : ''}*/}
                    {this.setState({ publicacionesActuales: this.state.publicaciones.slice((this.state.currentPagepublicaciones - 1) * this.state.itemPerPage, this.state.currentPagepublicaciones * this.state.itemPerPage), loadingpublicaciones: false })}
                    {this.state.loadingublicaciones & !this.state.vacia ? <Spinner /> :
                        this.state.publicacionesActuales.map((
                            { key, type, title, doi, url, authors, editors, details }, elemento) => {
                            return (
                                <div>
                                    <CardPublication key={(elemento + (this.state.itemPerPage * (this.state.currentPagepublicaciones - 1)))} num={(elemento + (this.state.itemPerPage * (this.state.currentPagepublicaciones - 1)))} title={title} authors={authors} editors={editors} citekey={key} type={type} details={details} doi={doi} url={url} totalPage={this.state.numTotal} />
                                </div>
                            );
                        })}
                </div>
                <Paginacion id={this.state.id} itemPerPage={this.state.itemPerPage} length={this.state.publicaciones.length} />
                {this.actualizacionDePagina()}
            </div>
        );

    }

}

function CardPublication(props) {
    const [visible, setVisible] = useState(false);
   

    function handleButtonClick() {
        setVisible(!visible);
        

    }

    return (
        <div key={props.key}>
            <div className='publicaciones-card'>
                <div className="description">
                    <div className="titulo" id='titulo'>
                        <h1><b>{props.title}</b></h1>
                    </div>
                    <div id='cuerpoPrevio' className="cuerpoPrevio" >
                        {props.type === 'journalArticle' && <text>{props.details.publicationTitle}</text>}
                        {props.type === 'conferencePaper' && <text>{props.details.conferenceName}</text>}
                        {props.type === 'bookSection' && <text>{props.details.bookTitle}</text>}
                        <br />
						
                        {props.type === 'journalArticle' && <text>{props.details.date} | Journal Article</text>}
                        {props.type === 'conferencePaper' && <text>{props.details.date} | Conference Paper</text>}
                        {props.type === 'bookSection' && <text>{props.details.date} | Book Section</text>}
                        {props.type === 'book' && <text>{props.details.date} | Book</text>}
                        <br />
						{props.doi && <text>DOI: <a href={'https://doi.org/' + props.doi} target="_blank" rel="noopener noreferrer">{props.doi}</a><br /></text>}
                        {props.url && <text>url: <a href={props.url} target="_blank" rel="noopener noreferrer">{props.url}</a><br /></text>}
                        <text>AUTHORS: </text>
                        {props.authors.map((author, index) => (
                            <text key={index}> {author.lastName}, {author.firstName}{index + 1 === props.authors.length ? '' : ';'}</text>
                        ))}
						<br />
						<text><a href={'https://api.zotero.org/groups/5287048/items/' + props.citekey + '?format=bibtex'} rel="noopener noreferrer">BibTeX</a><br /></text>
                        
                    </div>


                    {visible &&
                        <div className="desplegable">
                            <text><b>Authors</b></text>
                            <br />
                            {props.authors.map((author, index) => (
                                <text key={index}> {author.lastName}, {author.firstName} {index + 1 === props.authors.length ? '' : <br />}</text>
                            ))}
                            <br />
                            {props.type === 'journalArticle' &&
                                <div>
                                    <br />
                                    <text><b>Journal information</b></text>
                                    <br />
                                    <text>Journal Name: {props.details.publicationTitle}</text>
                                    <br />
                                    {props.details.volume && <text>Volume:  {props.details.volume}<br /></text>}
                                    {props.details.issue && <text>Issue:  {props.details.issue}<br /></text>}
                                    {props.details.pages && <text>Pages:  {props.details.pages}<br /></text>}								
                                    {props.details.issn && <text>ISSN:  {props.details.issn}<br /></text>}
                                    <br />
                                </div>
                            }
                            {props.type === 'conferencePaper' &&
                                <div>
                                    <br />
                                    <text><b>Conference information</b></text>
                                    <br />
                                    <text>Conference Name: {props.details.conferenceName}</text>
                                    <br />
									{props.details.proceedingsTitle && <text>Proceedings Title: {props.details.proceedingsTitle}<br /></text>}
									{props.details.place && <text>Location: {props.details.place}<br /></text>}
									{props.details.publisher && <text>Publisher: {props.details.publisher}<br /></text>}
									{props.details.pages && <text>Pages: {props.details.pages}<br /></text>}
									{props.details.isbn && <text>ISBN: {props.details.isbn}<br /></text>}

                                </div>
                            }
                            {props.type === 'bookSection' ?
                                <div>
                                    <br />
									<text><b>Editors</b></text>
									<br />
                                    {props.editors.map((editor, index) => (
                                    <text key={index}> {editor.lastName}, {editor.firstName} {index + 1 === props.editors.length ? '' : <br />}</text>
                                    ))}
                                    <br />
							        <br />
                                    <text><b>Book information</b></text>
                                    <br />
                                    <text>Book Title: {props.details.bookTitle}</text>
                                    <br />
									{props.details.publisher && <text>Publisher: {props.details.publisher}<br /></text>}
									{props.details.place && <text>Place: {props.details.place}<br /></text>}
									{props.details.edition && <text>Edition: {props.details.edition}<br /></text>}
									{props.details.pages && <text>Pages: {props.details.pages}<br /></text>}
									{props.details.isbn && <text>ISBN: {props.details.isbn}<br /></text>}
                                </div> : ''}
                        </div>
                    }
                    <div className='pie'>
                    <div className='Pagina'>
                        <text>Item: {props.num + 1} of {props.totalPage}</text>
                    </div>
                    <div className="enlace">
                        <a onClick={handleButtonClick}>Show {visible ? 'less' : 'more'} details</a>
                    </div>
                    </div>
                </div>

            </div>
        </div>
    );
}



export default CardPublications;
